import { render, staticRenderFns } from "./CreateSubAccount.vue?vue&type=template&id=7018d7e5&scoped=true&"
import script from "./CreateSubAccount.vue?vue&type=script&lang=js&"
export * from "./CreateSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubAccount.vue?vue&type=style&index=0&id=7018d7e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7018d7e5",
  null
  
)

export default component.exports